import './App.css';
import Header from './Components/Header/Header';
import Meme from './Components/Meme/Meme';

function App() {
  return (
    <div className='main_div'>
      <Header/>
      <Meme/>
    </div>
  );
}

export default App;
